import { render, staticRenderFns } from "./Suppliers.vue?vue&type=template&id=5e3ee408&scoped=true"
import script from "./Suppliers.vue?vue&type=script&lang=ts"
export * from "./Suppliers.vue?vue&type=script&lang=ts"
import style0 from "./Suppliers.vue?vue&type=style&index=0&id=5e3ee408&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3ee408",
  null
  
)

export default component.exports